{
  "en": {
    "todo": {
      "actions": {
        "add": "Add Task",
        "cancel": "Cancel",
        "delete_todo": "Delete task",
        "edit": "Edit Task",
        "save": "Save"
      },
      "attributes": {
        "active": "Active",
        "assignee": "Responsible",
        "completed": "Completed",
        "description": "Description",
        "due_date": "Due date",
        "title": "Title"
      },
      "labels": {
        "active": "active",
        "allDone": "All todos are completed!",
        "allTodos": "All Tasks",
        "completed": "completed",
        "filterTodos": "Filter tasks",
        "filters": "Filters",
        "myTodos": "My Tasks",
        "myTodosCount": "My Tasks ({count})",
        "noActiveTodos": "No active todos",
        "noActiveTodosDashboard": "Congratulations, you have no open tasks!",
        "noCompletedYet": "No completed todos yet.",
        "noTodosCustomer": "Great! You don't have any open tasks.",
        "selectAProjectFirst": "Select a project first",
        "showLess": "Show less",
        "showOthers": "Show more | Show more ({count})"
      },
      "toasts": {
        "create": "Task created",
        "delete": "Task deleted",
        "update": "Task updated"
      },
      "validation": {
        "needtitle": "Title is required"
      }
    }
  }
}